import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Business from '@material-ui/icons/Business';
import { operators } from 'api/index'
import { useStoreState } from '../../../store/index'
import { MailOutlineSharp } from '../../../../node_modules/@material-ui/icons/index'
import { Alert, AlertTitle } from '../../../../node_modules/@material-ui/lab/index'
import Swal from 'sweetalert2'
import { useTranslation } from 'hooks/useTranslation'
export default function OrganizationDetailCardV3({
	mountType,
	senderState,
	confirmationInfo,
	onChangeSenderType,
	onChangeCompanyInfo,
	branchList = [], // Add branchList prop
}) {
	// eslint-disable-next-line
	const [selectPOAError, setSelectPOAError] = useState(false)
	// eslint-disable-next-line
	const [dbdData, setDbdData] = useState(null)
	const [isProfileError, setIsProfileError] = useState(false)
	const userSDOC = useStoreState(s => s.sdocUserModel.userSDOC)
	const history = useHistory();
	const { t } = useTranslation()

	const isCompany = (taxId) => {
		return taxId && taxId.startsWith('0');
	}

	const handleInput = async e => {
		const { name, value } = e.target

		let newData = confirmationInfo.organization
		onChangeCompanyInfo({ ...newData, [name]: value })

		if (name === 'branchNo') {
			if (value.length === 5) {
				const res = await operators.getOperatorInfo({ taxno: userSDOC?.poa, branchno: value });

				if (res && res?.status === 200 && res?.data.status !== 'error') {
					const data = res.data
					if (data.operatorInfo.zipcode?.length !== 5) {
						setIsProfileError(true)
						Swal.fire({
							icon: 'error',
							title: t('orgCard.invalidAddressTitle'),
							text: t('orgCard.invalidAddressMsg')(t('orgCard.userInfoMenu2')),
							confirmButtonText: t('orgCard.invalidAddressConfirm'),
							allowOutsideClick: false,
							allowEscapeKey: false,
						}).then((result) => {
							if (result.isConfirmed) {
								history.push('/sdoc/profile');
							}
						});

					}
					onChangeCompanyInfo({
						...newData,
						type: 'organization',
						name: data.operators.operatorName ?? '',
						// cardNo: data.operators.taxNo ?? '',
						prefix: data.operators.prefix ?? '',
						branchNo: value,
						address: data.operatorInfo.addr ?? '',
						// address: data.operatorInfo.address + ' ' + data.operatorInfo.district + ' ' + data.operatorInfo.amphoe + ' ' + data.operatorInfo.province + ' ' + data.operatorInfo.zipcode ?? '',
						addr: data.operatorInfo.addr ?? '',
						email: data.operatorInfo.email ?? '',
						mobile: data.operatorInfo.mobile ?? '',
						district: data.operatorInfo.district ?? '',
						amphoe: data.operatorInfo.amphoe ?? '',
						province: data.operatorInfo.province ?? '',
						zipcode: data.operatorInfo.zipcode ?? '',
					})
				} else {
					onChangeCompanyInfo({
						...newData,
						type: 'organization',
						// name: '',
						// cardNo: '',
						// prefix: '',
						branchNo: value,
						address: '',
						email: '',
						mobile: '',
					})
				}
			} else {
				onChangeCompanyInfo({
					...newData,
					type: 'organization',
					// name: '',
					// cardNo: '',
					// prefix: '',
					branchNo: value,
					address: '',
					addr: '',
					district: '',
					amphoe: '',
					province: '',
					zipcode: '',
					email: '',
					mobile: '',
				})
			}


		}
	}

	const handleBranchSelect = (event) => {
		const branchNo = event.target.value;
		let newData = confirmationInfo.organization;
		onChangeCompanyInfo({ ...newData, branchNo: branchNo });

		const selectedBranch = branchList.find(b => b.branchNo === branchNo);

		if (selectedBranch) {
			onChangeCompanyInfo({
				...newData,
				branchNo: branchNo,
				name: newData.name,
				cardNo: newData.cardNo,
				prefix: newData.prefix,
				address: selectedBranch.addr ?? selectedBranch.address ?? '',
				email: selectedBranch.email ?? '',
				mobile: selectedBranch.mobile ?? '',
				district: selectedBranch.district ?? '',
				amphoe: selectedBranch.amphoe ?? '',
				province: selectedBranch.province ?? '',
				zipcode: selectedBranch.zipcode ?? '',
			});
		}
	}

	return (
		<Card className={`border-t-4 border-card_top_border mb-5`}>
			<Grid className="flex flex-col justify-center items-start px-5 mb-5">
				{/* Header */}
				<Grid className="flex flex-row mt-4 mb-2">
					<Business style={{ fontSize: 22 }} className="mr-1" />
					<Grid className="font-bold text-sm text-card_header_color">
						{t('orgCard.header')}
					</Grid>
				</Grid>
				<Grid className="mt-3 mb-1 w-full">
					<Divider />
				</Grid>
				{/* Normal Person or Organization */}
				{!mountType && <Alert severity="warning" className="w-full"><AlertTitle>{t('orgCard.editWarningTitle')}</AlertTitle>{t('orgCard.editWarningMsg')(t('orgCard.userInfoMenu'))}</Alert>}

				<Grid className="flex flex-row items-center justify-between w-full">
					<Grid className="flex flex-col gap-y-2 mt-4">
						<Grid>{t('orgCard.senderTypeLabel')}</Grid>
						<RadioGroup
							row
							name="type"
							value={senderState}
							onChange={onChangeSenderType}>
							<FormControlLabel
								value={'normal_person'}
								control={<Radio />}
								label={t('orgCard.normalPerson')}
								disabled={mountType}
							/>
							{(mountType || userSDOC?.poa) && (
								<FormControlLabel
									value={'organization'}
									control={<Radio />}
									label={isCompany(confirmationInfo.organization.cardNo) ? t('orgCard.organization') : t('orgCard.shop')}
									disabled={mountType}
								/>
							)}
						</RadioGroup>
					</Grid>
				</Grid>
				{/* Normal Person or Organization's Name */}
				{senderState === 'normal_person' && (
					<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
						<Grid className="flex flex-row">
							<Grid>{t('orgCard.fullName')}</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<Grid
							className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
							<InputBase
								className="w-full"
								name="confirmationInfoName pointer-events-none"
								readOnly
								disabled
								value={confirmationInfo.normal_person.name}
							/>
						</Grid>
						<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							<Grid className="flex flex-row">
								<Grid>{t('orgCard.nationalID')}</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
								<InputBase
									className="w-full"
									name="cardNo"
									readOnly
									disabled
									value={confirmationInfo.normal_person.cardNo}
								/>
							</Grid>
						</Grid>
						<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							<Grid className="flex flex-row">
								<Grid>{t('orgCard.address')}</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
								<InputBase
									className="w-full"
									name="address"
									readOnly
									disabled
									value={confirmationInfo.normal_person.address}
								// onChange={handleInput}
								/>
							</Grid>
						</Grid>
						<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							<Grid className="flex flex-row">
								<Grid>Email</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
								<InputBase
									className="w-full"
									name="email"
									readOnly
									disabled
									type="email"
									value={confirmationInfo.normal_person.email}
								// onChange={handleInput}
								/>
							</Grid>
						</Grid>
						<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							<Grid className="flex flex-row">
								<Grid>{t('orgCard.phone')}</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
								<InputBase
									className="w-full"
									name="mobile"
									readOnly
									disabled
									value={confirmationInfo.normal_person.mobile}
								// onChange={handleInput}
								/>
							</Grid>
						</Grid>
					</Grid>
				)}

				{senderState === 'organization' && (
					<>
						<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							{/* {!mountType && (
								<Grid className="flex flex-row">
									<Grid>
										<Button
											className="text-white w-full"
											onClick={handleSearchCompany}
											variant="contained"
											color="secondary"
											size="large"
											id="signin-button">
											ตรวจสอบข้อมูลนิติบุคคล
										</Button>
									</Grid>
								</Grid>
							)} */}
							<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
								<Grid className="flex flex-row">
									<Grid>{t('orgCard.taxID')}</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<Grid
									className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
									<InputBase
										className="w-full"
										name="cardNo"
										readOnly
										disabled
										value={confirmationInfo.organization.cardNo}
									// value={userSDOC.poa}
									/>
								</Grid>
							</Grid>

							<Grid style={{ display: 'none' }} className={`flex flex-col items-start my-2 w-full gap-y-3`}>
								<Grid className="flex flex-row">
									<Grid>ประเภทสถานประกอบการ</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<Grid
									className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
									<InputBase
										className="w-full"
										name="nameType"
										value={confirmationInfo.organization.nameType}
										// onChange={handleInput}
										readOnly
										disabled
									/>
								</Grid>
							</Grid>
							<Grid className="flex flex-row">
								<Grid>{isCompany(confirmationInfo.organization.cardNo) ? t('orgCard.companyPrefix') : t('orgCard.shopType')}</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
								<InputBase
									className="w-full"
									name="prefix"
									value={confirmationInfo.organization.prefix}
									// placeholder="คำนำหน้าชื่อบริษัท"
									readOnly
									disabled
								// onChange={handleInput}
								/>
								{/* <Select
									className="w-full"
									name="prefix"
									// onChange={handleInput}
									readOnly={mountType && mountType === 'readOnly'}
									value={confirmationInfo.organization.prefix}
								>
									<MenuItem value={"บริษัท"}>บริษัท</MenuItem>
									<MenuItem value={"ห้างหุ้นส่วน"}>ห้างหุ้นส่วน</MenuItem>
									<MenuItem value={"ห้างหุ้นส่วนจำกัด"}>ห้างหุ้นส่วนจำกัด</MenuItem>
									<MenuItem value={"สหกรณ์"}>สหกรณ์</MenuItem>
									<MenuItem value={"อื่นๆ"}>อื่น ๆ</MenuItem>

								</Select> */}
								{/* {confirmationInfo.organization.prefix === "อื่นๆ" && (
									<InputBase
										className="w-full"
										name="prefixother"
										value={confirmationInfo.organization.prefixother}
										placeholder="ระบุ"
										onChange={handleInput}
									/>
								)} */}

							</Grid>
							<Grid className="flex flex-row">
								<Grid>{isCompany(confirmationInfo.organization.cardNo) ? t('orgCard.companyName') : t('orgCard.shopName')}</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
								<InputBase
									className="w-full"
									name="name"
									// onChange={handleInput}
									readOnly
									disabled
									value={confirmationInfo.organization.name}

								/>
							</Grid>
						</Grid>
						<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							<Grid className="flex flex-row">
								<Grid>{t('orgCard.branchNo')}</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded ${(mountType && (mountType === 'readOnly' || mountType === 'ApprovalControl')) ? 'h-10 border border-gray-300' : 'h-full'} w-full `}>
								{(mountType && (mountType === 'readOnly' || mountType === 'ApprovalControl')) ? (
									<InputBase
										className="w-full"
										name="branchNo"
										readOnly
										disabled
										value={confirmationInfo.organization.branchNo}
									/>
								) : (
									<FormControl variant="outlined" className="w-full" size="small">
										<Select
											name="branchNo"
											value={confirmationInfo.organization.branchNo}
											onChange={handleBranchSelect}
											displayEmpty
											disabled={(mountType && mountType === 'readOnly')}
										>
											<MenuItem value="" disabled>{t('orgCard.selectBranch')}</MenuItem>
											{branchList.map((branch) => (
												<MenuItem key={branch.branchNo} value={branch.branchNo}>
													{branch.branchNo}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								)}
							</Grid>
						</Grid>
						<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							<Grid className="flex flex-row">
								<Grid>{t('orgCard.address')}</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
								<InputBase
									className="w-full"
									name="address"
									value={confirmationInfo.organization.address}
									// onChange={handleInput}
									readOnly
									disabled
								/>
							</Grid>
						</Grid>
						<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							<Grid className="flex flex-row">
								<Grid>Email</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
								<InputBase
									className="w-full"
									name="email"
									// onChange={handleInput}
									readOnly
									disabled
									value={confirmationInfo.organization.email}
								/>
							</Grid>
						</Grid>

						<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							<Grid className="flex flex-row">
								<Grid>{t('orgCard.phone')}</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
								<InputBase
									className="w-full"
									name="mobile"
									// onChange={handleInput}
									readOnly
									disabled
									value={confirmationInfo.organization.mobile}
								/>
							</Grid>
						</Grid>

					</>
				)}

				{/* Card Number */}

				{/* Address */}
			</Grid>
		</Card >
	)
}
